export const getAdminOperatorList = (state) => {
  return state.operatorList;
};

export const getOperatorEditModal = (state) => {
  const { showOperatorEntryModal } = getAdminOperatorList(state);
  return showOperatorEntryModal;
};

export const getOperatorMergeModal = (state) => {
  const { showOperatorMergeModal } = getAdminOperatorList(state);
  return showOperatorMergeModal;
};

export const getOperatorAddModal = (state) => {
  const { showOperatorAddModal } = getAdminOperatorList(state);
  return showOperatorAddModal;
};

export const getSelectedOperator = (state) => {
  const { operator } = getAdminOperatorList(state);
  return operator;
};

export const getSelectedOperatorId = (state) => {
  const operator = getSelectedOperator(state);
  if (!operator) {
    return null;
  }
  return operator.id;
};
